import Image from 'global/Image';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import { Checkbox } from '../styled';

interface CommentSettingItemProps {
  icon: string;
  label: string;
  isActive: boolean;
  onChange: () => void;
  [key: string]: any;
}

function CommentSettingItem({
  icon,
  label,
  isActive,
  onChange,
  type,
}: CommentSettingItemProps) {
  return (
    <Flex
      className="comment-setting-item"
      justify="space-between"
      // @ts-expect-error
      mt="15px"
      py="3px"
      pr="3px"
      align="center"
    >
      <Flex align="center" width="16" height="16">
        <Image src={`icon/${icon}`} />
        {/* @ts-expect-error */}
        <Text ml="12px" weight="400">
          {label}
        </Text>
      </Flex>
      <Checkbox
        className={`comment-setting-checkbox-${type}`}
        checked={isActive}
        onChange={onChange}
      />
    </Flex>
  );
}

export default CommentSettingItem;
